import React from 'react';
import { formatWeight } from '../../utils/formatHelpers';

const CustomersChart = ({ data, loading, drillData, drillLoading, onBarClick, onDrillClose }) => {
  if (loading) return <div className="chart-loading">Loading customer data...</div>;
  if (!data || data.length === 0) {
    return <div className="chart-empty">No customer data available for this period.</div>;
  }

  const maxVal = Math.max(...data.map(d => d.shipment_count || 0), 1);

  return (
    <div className="chart-section">
      <div className="h-bar-chart">
        {data.map((row, idx) => {
          const pct     = Math.round((row.shipment_count / maxVal) * 100);
          const isActive = drillData?.customer_id === row.customer_id;

          return (
            <div
              key={row.customer_id}
              className={`h-bar-row ${isActive ? 'h-bar-row--active' : ''}`}
              onClick={() => onBarClick && onBarClick(row)}
              role="button"
              tabIndex={0}
              aria-label={`${row.customer_name}: ${row.shipment_count} shipments. Click for details.`}
              onKeyDown={e => e.key === 'Enter' && onBarClick && onBarClick(row)}
            >
              <div className="h-bar-rank">#{idx + 1}</div>
              <div className="h-bar-name" title={row.customer_name}>{row.customer_name}</div>
              <div className="h-bar-track">
                <div className="h-bar-fill" style={{ width: pct + '%' }} />
              </div>
              <div className="h-bar-meta">
                <span className="h-bar-count">{row.shipment_count}</span>
                <span className="h-bar-sub">{formatWeight(row.total_weight)}</span>
              </div>
            </div>
          );
        })}
      </div>

      {drillData && (
        <div className="drill-down">
          <div className="drill-down__header">
            <h3 className="drill-down__title">
              {drillData.customer_name} — Shipment History
            </h3>
            <button className="drill-down__close" onClick={onDrillClose} aria-label="Close drill-down">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
              Close
            </button>
          </div>

          {drillLoading ? (
            <div className="drill-down__loading">Loading...</div>
          ) : !drillData.rows || drillData.rows.length === 0 ? (
            <div className="drill-down__empty">No shipments found for this customer.</div>
          ) : (
            <div className="results-table-container">
              <table className="results-table">
                <thead>
                  <tr>
                    <th>Shipment #</th>
                    <th>Invoice #</th>
                    <th>Pallets</th>
                    <th>Weight</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {drillData.rows.map(s => (
                    <tr key={s.id}>
                      <td className="shipment-number">{s.shipment_number}</td>
                      <td>{s.invoice_number || '-'}</td>
                      <td>{s.pallet_count || 0}</td>
                      <td>{formatWeight(s.total_weight)}</td>
                      <td><span className={`status-badge ${s.status}`}>{s.status}</span></td>
                      <td>{s.date_label}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomersChart;
